export const fetchAuthInfosStartHandler = (state, productId) => ({
  ...state,
  products: {
    ...state.products,
    [productId]: {
      ...state.products[productId],
      loadingAuthInfos: true
    }
  }
});
export const fetchAuthInfosSuccessHandler = (state, args) => ({
  ...state,
  products: {
    ...state.products,
    [args.productId]: {
      ...state.products[args.productId],
      loadingAuthInfos: false,
      authcodeNeeded: args.data.transfer_needed
    }
  }
});
export const fetchAuthInfosFailHandler = (state, productId) => ({
  ...state,
  products: {
    ...state.products,
    [productId]: {
      ...state.products[productId],
      loadingAuthInfos: false,
      errorLoadingAuthInfos: true
    }
  }
});